<template>
<div style=" padding:20px;margin-top:10px;background: #fff;  ">
<el-form ref="form" :model="form"  label-width="100px" style="margin: 50px">
  <el-form-item label="发票抬头" required>
    <el-input v-model="form.company_name"></el-input>
  </el-form-item>
  <el-form-item label="税号" required>
    <el-input v-model="form.company_taxId"></el-input>
  </el-form-item>
  <el-form-item label="收件人" >
    <el-input v-model="form.shipName"></el-input>
  </el-form-item>
  <el-form-item label="收件人电话">
     <el-input v-model="form.shipTel"></el-input>
  </el-form-item> 
  <el-form-item label="收件人地址">
     <el-input v-model="form.shipAddress"></el-input>
  </el-form-item> 
  <el-form-item label="备注">
     <el-input v-model="form.remark"></el-input>
  </el-form-item>  
  <el-form-item>
    <el-button type="primary" :loading="is_loading" @click="onSubmit" >提交</el-button> 
	
  </el-form-item>
</el-form>
</div>
</template>
 
<script>
export default {
    data() {
      return {
	    is_loading: false,
		loading: true,
		size: '',
        form: {
          invoice_date: '',
		  company_name: '',
		  company_taxId: '',
		  invoiceId: '', 
		  shipName: '',
		  shipTel: '',
		  shipAddress: '',
		  remark: '',
        }
      }
    },

    methods: {
	  getInfo(){ 
	  
	  },
	  
      onSubmit() { 
	    let that = this;
	    let userInfo = localStorage.getItem('userInfo');
		let info = JSON.parse(userInfo);
		let id = info.id; 
		let order_id =  localStorage.getItem('orderId'); 	
		that.is_loading = true;
        console.log(that.form.birthday);  
		  $.ajax({
              type: "POST",
			  data: {
                order_id: order_id,
                user_id: id,				
			    company_name: that.form.company_name,
		        company_taxId: that.form.company_taxId,
		        shipName: that.form.shipName,
		        shipTel: that.form.shipTel,
		        shipAddress: that.form.shipAddress,
		        remark: that.form.remark } ,
              url: "https://www.myferp.com/admin/user/invoiceApply",
              dataType: "json",  //返回类型为 json
              beforeSend: function (request) {
                request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
                },   
              error: function(XMLHttpRequest, textStatus, errorThrown) { 
 		          that.is_loading = false;
			      Vue.prototype.$message({
                    message: data,
                    type: 'error'
                    });
                        return false;
                    },             
              success: function (data) {
		        that.is_loading = false;
				console.log(JSON.stringify(data));
				Vue.prototype.$message({
                  message: data,
                  type: 'success'
                  });
                }
              });	
			 
			     
      }
    },
    mounted() { 
	},
  }
</script>
 
 


// WEBPACK FOOTER //
// src/components/setting/invoiceApply.vue